import React, { useRef } from 'react';
import { MTextBlockSimple } from '../../molecules/MTextBlockSimple';
import { MMediaSelector } from '../../molecules/MMediaSelector';
import { MTextBlockSimpleAlignment } from '../../molecules/MTextBlockSimple/MTextBlockSimple.types';
import * as Styled from './OBannerSplit.styles';
import {
  OBannerSplitProps,
  OBannerSplitImageScale,
  OBannerSplitInset,
  OBannerSplitLayout,
  OBannerSplitContentAlignment,
} from './OBannerSplit.types';
import { useTracking } from '../../hooks';

const COMPONENT_NAME = 'OBannerSplit';
const TEST_ID = 'OBannerSplit';

export const OBannerSplit: React.FC<OBannerSplitProps> = ({
  imageScale = OBannerSplitImageScale.S,
  inset = OBannerSplitInset.None,
  layout = OBannerSplitLayout.Default,
  contentAlignment = OBannerSplitContentAlignment.Left,
  mTextBlockSimple,
  mButton,
  mMediaSelector,
  mediaColorSet,
  trackingProperties,
  className,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useTracking({ ref: containerRef, trackingProperties });

  const resolvedLayout = layout as OBannerSplitLayout;
  const resolvedImageScale = imageScale as OBannerSplitImageScale;
  const resolvedInset = inset as OBannerSplitInset;
  const resolvedAlignment = contentAlignment as OBannerSplitContentAlignment;

  const isReversed = resolvedLayout === OBannerSplitLayout.Reverse;
  const isCentered = resolvedAlignment === OBannerSplitContentAlignment.Centered;

  return (
    <Styled.Container
      ref={containerRef}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
    >
      <Styled.MediaSection $imageScale={resolvedImageScale} $order={isReversed ? 0 : 1} className={mediaColorSet || ''}>
        {mMediaSelector && <MMediaSelector {...mMediaSelector} />}
      </Styled.MediaSection>

      <Styled.ContentSection $inset={resolvedInset} $alignment={resolvedAlignment}>
        <Styled.ContentWrapper>
          {mTextBlockSimple && (
            <Styled.TextBlockWrapper>
              <MTextBlockSimple
                {...mTextBlockSimple}
                alignment={isCentered ? MTextBlockSimpleAlignment.Center : MTextBlockSimpleAlignment.Left}
              />
            </Styled.TextBlockWrapper>
          )}

          {mButton && <Styled.ButtonWrapper $alignment={resolvedAlignment}></Styled.ButtonWrapper>}
        </Styled.ContentWrapper>
      </Styled.ContentSection>
    </Styled.Container>
  );
};
